import { useState } from 'react'
import { message as $message } from 'antd'

import { queryOperateFreshmanGoods, queryOperateFreshmanGoodsPrice } from '@/services/alreadyReleaseGoods'

export default () => {
    const [operateFreshmanGoodsLoading, setOperateFreshmanGoodsLoading] = useState(true)
    const [operateFreshmanGoods, setOperateFreshmanGoods] = useState([])

    const loadOperateFreshmanGoods = async goodsProps => {
        const { onlyUpdateExtendData } = goodsProps || {}
        try {
            setOperateFreshmanGoodsLoading(true)
            const { data, success, message } = await queryOperateFreshmanGoods()
            setOperateFreshmanGoodsLoading(false)
            if (!success) {
                $message.error(message)
            }

            if (Array.isArray(data) && data.length > 0) {
                if (!onlyUpdateExtendData) {
                    setOperateFreshmanGoods(data)
                }
                const params = data.map(item => {
                    return {
                        coId: item?.coId,
                        itemCoId: item?.coId,
                        spuId: item?.spuId
                    }
                })
                const { data: goodsPriceData } = await queryOperateFreshmanGoodsPrice(params)
                let goodsList = data.map(item => {
                    if (Array.isArray(goodsPriceData) && goodsPriceData.length > 0) {
                        const priceInfo = goodsPriceData.find(v => v.spuId === item.spuId)
                        if (priceInfo) {
                            return {
                                ...item,
                                ...priceInfo
                            }
                        }
                        return item
                    }

                    return item
                })
                setOperateFreshmanGoods(goodsList)
            }
        } catch (error) {
            console.error('获取运营推荐商品失败', error)
        }
    }

    return {
        operateFreshmanGoodsLoading,
        operateFreshmanGoods,
        loadOperateFreshmanGoods
    }
}
